export default "__VITE_ASSET__6ntE3fPx__"